import React from 'react';
import './App.css';
import PhotosDragAndDropApp from './containers/PhotosDragAndDropApp/PhotosDragAndDrop';

const App = () => (
  <PhotosDragAndDropApp />
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js